/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  TaskBoxesParticipantsResponse,
  TaskBoxesResponse,
  TaskResponsePaginated,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    TaskBoxesParticipantsResponseFromJSON,
    TaskBoxesParticipantsResponseToJSON,
    TaskBoxesResponseFromJSON,
    TaskBoxesResponseToJSON,
    TaskResponsePaginatedFromJSON,
    TaskResponsePaginatedToJSON,
} from '../models/index';

export interface CountTaskRequest {
    taskBoxUuid?: string;
    futureTasks?: boolean;
    withSettled?: boolean;
}

export interface GetParticipantsByTaskBoxRequest {
    taskBoxId: string;
}

export interface GetTaskBoxesRequest {
    justTwoPersonChannel?: boolean;
}

export interface GetTaskByStatusRequest {
    status?: string;
    priorityType?: string;
    taskBoxUuid?: string;
    futureTasks?: boolean;
    start?: number;
    limit?: number;
}

/**
 * 
 */
export class TaskApi extends runtime.BaseAPI {

    /**
     * Get task by status for connected user
     */
    async countTaskRaw(requestParameters: CountTaskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        const queryParameters: any = {};

        if (requestParameters['taskBoxUuid'] != null) {
            queryParameters['taskBoxUuid'] = requestParameters['taskBoxUuid'];
        }

        if (requestParameters['futureTasks'] != null) {
            queryParameters['futureTasks'] = requestParameters['futureTasks'];
        }

        if (requestParameters['withSettled'] != null) {
            queryParameters['withSettled'] = requestParameters['withSettled'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/tasks/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Get task by status for connected user
     */
    async countTask(requestParameters: CountTaskRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.countTaskRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get participants of taskBox
     */
    async getParticipantsByTaskBoxRaw(requestParameters: GetParticipantsByTaskBoxRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TaskBoxesParticipantsResponse>> {
        if (requestParameters['taskBoxId'] == null) {
            throw new runtime.RequiredError(
                'taskBoxId',
                'Required parameter "taskBoxId" was null or undefined when calling getParticipantsByTaskBox().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/task-boxes/{task_box_id}/participants`.replace(`{${"task_box_id"}}`, encodeURIComponent(String(requestParameters['taskBoxId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TaskBoxesParticipantsResponseFromJSON(jsonValue));
    }

    /**
     * Get participants of taskBox
     */
    async getParticipantsByTaskBox(requestParameters: GetParticipantsByTaskBoxRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TaskBoxesParticipantsResponse> {
        const response = await this.getParticipantsByTaskBoxRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get taskBoxes for connected user
     */
    async getTaskBoxesRaw(requestParameters: GetTaskBoxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TaskBoxesResponse>>> {
        const queryParameters: any = {};

        if (requestParameters['justTwoPersonChannel'] != null) {
            queryParameters['justTwoPersonChannel'] = requestParameters['justTwoPersonChannel'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/task-boxes`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TaskBoxesResponseFromJSON));
    }

    /**
     * Get taskBoxes for connected user
     */
    async getTaskBoxes(requestParameters: GetTaskBoxesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TaskBoxesResponse>> {
        const response = await this.getTaskBoxesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get task by status for connected user
     */
    async getTaskByStatusRaw(requestParameters: GetTaskByStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TaskResponsePaginated>> {
        const queryParameters: any = {};

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['priorityType'] != null) {
            queryParameters['priorityType'] = requestParameters['priorityType'];
        }

        if (requestParameters['taskBoxUuid'] != null) {
            queryParameters['taskBoxUuid'] = requestParameters['taskBoxUuid'];
        }

        if (requestParameters['futureTasks'] != null) {
            queryParameters['futureTasks'] = requestParameters['futureTasks'];
        }

        if (requestParameters['start'] != null) {
            queryParameters['start'] = requestParameters['start'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/tasks`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TaskResponsePaginatedFromJSON(jsonValue));
    }

    /**
     * Get task by status for connected user
     */
    async getTaskByStatus(requestParameters: GetTaskByStatusRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TaskResponsePaginated> {
        const response = await this.getTaskByStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
